const video_code = (url) => {
    if (url.indexOf('https://youtu.be/') !== -1) return url.replace('https://youtu.be/','').replace(/[^a-zA-Z0-9]/g, '')
    const match = url.match(/[?&]v=([^&]+)/)

    if (match && match[1]) {
        return match[1]
    }
}

module.exports = video_code